import {EventAirportPatch} from "../../types/domain.ts";
import {baseRequestService} from "../base.ts";

export const eventsEventIdAirportsAirportIdPatch = (eventId: string, airportId: string, data: EventAirportPatch) => baseRequestService({
    url: `/events/${eventId}/airports/${airportId}`,
    method: 'PATCH',
    data
})